import { EXERCISES_UPDATE } from '../actions/types';
import { ExerciseRecord, ExerciseSearchFilters, ExerciseSearchItem } from '../api/exercises.interface';

export interface ExercisesState {
    loadingList: boolean;
    loadingItem: boolean;
    savingItem: boolean;
    deletingTag?: number;
    searchFilters: ExerciseSearchFilters;
    items: ExerciseSearchItem[];
    selectedIndex?: number;
    selectedItem?: ExerciseRecord;
    hasLoadedSearch: boolean;
}

const InitialState: ExercisesState = {
    loadingItem: false,
    loadingList: false,
    savingItem: false,
    searchFilters: {},
    items: [],
    hasLoadedSearch: false,
};

export const ExercisesReducer = (state: ExercisesState = InitialState, action: any) => {
    switch (action.type) {
        case EXERCISES_UPDATE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default ExercisesReducer;